//mypreset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { palette } from '@primeuix/themes';

const primary = palette('#34a835');

export const MyPreset = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '15px',
            sm: '15px',
            md: '15px', 
            lg: '15px', 
            xl: '15px'
        }
    },
    semantic: {
        primary: {
            50: primary[50],
            100: primary[100],
            200: primary[200],
            300: primary[300],
            400: primary[400],
            500: primary[500],
            600: primary[600],
            700: primary[700],
            800: primary[800],
            900: primary[900],
            950: primary[950]
        }
    },
    components: {
        // button: {
        //     root: {
        //         borderRadius: '15px'
        //     }
        // },
        card: {
            root: {
                borderRadius: '15px',
                background: '#ebebeb',
                shadow: 'rgba(0, 0, 0, 0.2) 0px 1px 3px 0px'
            }
        },
        checkbox: {
            root: {
                borderRadius: '2px'
            }
        },
        drawer: {
            content: {
                padding: '10px'
            }
        },
        floatlabel: {
            root: {
                color: '{gray.400}',
                focusColor: '{gray.400}',
                activeColor: '{gray.400}',
            }
        },
        inputtext: {
            root: {
                focusBorderColor: '{gray.400}'
            }
        },
        menubar: {
            root: {
                borderColor: 'transparent'
            },
            item: {
                padding: '12px'
            }
        },
        datatable: {
            headerCell: {
                background: '{gray.100}',
                selectedBackground: '{gray.200}',
                selectedColor: '{gray.700}',
            }
        },
        paginator: {
            root: {
                background:  '{gray.100}',
                borderRadius: '0px',
                color: '{gray.700}'
            },
            navButton: {
                background:  '{gray.100}',
                selectedBackground: '{gray.200}',
                color: '{gray.700}',
                selectedColor: '{gray.700}',
            }
        },
        tabs: {
            activeBar: {
                background: '{gray.400}',
            },
            tab: {
                background: '{gray.400}',
                borderColor: '{gray.400}',
                borderWidth: "1px",
                activeBackground: '{gray.300}',
                activeBorderColor: '{gray.300}',
                activeColor: '{stone.800}',
                color: '{stone.800}'
            },
            tabpanel: {
                padding: '0px'
            }
        }
    }
});